import { get } from "@/request/http";

// 获取学校列表
// 文档地址：http://showdoc.mools.net/web/#/13?page_id=102
export const getSchoolList = p => get("/login/getSchoolList", p);
